import { useState, useEffect } from 'react'

import { useStoreContext } from 'hooks/StoreContext'

import { Device } from 'types/Device'

import Api from 'services/api'

const useDevice = (dealerId, deviceId) => {
  const { devicesCache } = useStoreContext()

  const [device, setDevice] = useState<Device | null>(devicesCache[deviceId] ? devicesCache[deviceId] : null)
  const [isDeviceLoaded, setIsDeviceLoaded] = useState(device !== null)

  useEffect(() => {
    Api.Device.get(dealerId, deviceId)
      .then((res: Device | null) => {
        devicesCache[deviceId] = res
        setDevice(res)
      }).catch(() => {
        devicesCache[deviceId] = null
        setDevice(null)
      }).finally(() => {
        setIsDeviceLoaded(true)
      })
  }, [deviceId, dealerId]) // eslint-disable-line react-hooks/exhaustive-deps

  return { device, isDeviceLoaded }
}

export default useDevice
